var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStore = function SvgStore(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 74,
    viewBox: "0 0 89 74",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Einzelh\xE4ndler") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#183E62",
    strokeWidth: 2,
    d: "M86.025 17.685 76.858 3.11A4.53 4.53 0 0 0 73.03 1H15.965a4.53 4.53 0 0 0-3.828 2.11L2.97 17.685c-4.732 7.526-.537 17.993 8.305 19.188.636.085 1.285.127 1.935.127 4.181 0 7.882-1.829 10.425-4.657A14 14 0 0 0 34.059 37c4.18 0 7.882-1.829 10.424-4.657A14 14 0 0 0 54.907 37c4.181 0 7.882-1.829 10.425-4.657C67.888 35.171 71.589 37 75.756 37c.664 0 1.3-.042 1.935-.127 8.87-1.181 13.08-11.648 8.334-19.188ZM75.135 41.67c-1.407 0-2.8-.21-4.15-.531v13.958h-54V41.14c-1.35.308-2.741.531-4.148.531-.843 0-1.701-.056-2.53-.168A18 18 0 0 1 8 41v27.524C8 71 10.01 73 12.5 73h63c2.49 0 4.5-2 4.5-4.476V41c-.76.224-1.519.406-2.306.503-.858.112-1.702.168-2.56.168Z"
  })));
};
export default SvgStore;